import type { Company } from "@/modules/companies/client/api/types"
import type { TranslationKey } from "@/modules/i18n/components/types"

import { COMPANY_PAGE_TYPE } from "@/modules/companies/client/api/endpoints/company"

type CompanyRoute = {
  id: string
  path: string
  translationKey: TranslationKey<"companies_client">
  translationVariable: string | null
}

export const COMPANY_BASENAME = "companies"
export const COMPANY_TEAMS = "teams"
export const COMPANY_JOB_OFFERS = "job-offers"
export const COMPANY_NEWSFEED = "newsfeed"

const HOME_PAGE_ROUTE: CompanyRoute = {
  id: "0",
  path: "",
  translationKey: "companies_client.menu.purpose",
  translationVariable: null,
}
export const TEAMS_PAGE_ROUTE: CompanyRoute = {
  id: "1",
  path: `/${COMPANY_TEAMS}`,
  translationKey: "companies_client.menu.teams",
  translationVariable: null,
}
const JOBS_PAGE_ROUTE: CompanyRoute = {
  id: "2",
  path: `/${COMPANY_JOB_OFFERS}`,
  translationKey: "companies_client.menu.jobAds_plural",
  translationVariable: "jobAdsNumber",
}
export const NEWSFEED_PAGE_ROUTE: CompanyRoute = {
  id: "3",
  path: `/${COMPANY_NEWSFEED}`,
  translationKey: "companies_client.menu.newsfeed",
  translationVariable: null,
}
const BOOSTED_NEWSFEED_PAGE_ROUTE: CompanyRoute = {
  id: "3",
  path: `/${COMPANY_NEWSFEED}`,
  translationKey: "companies_client.menu.boosted_newsfeed",
  translationVariable: null,
}

export const getCompanyRoutes = (company: Company | undefined, isJobAdsContentBoostActive: boolean): CompanyRoute[] => {
  if (company?.pageType === COMPANY_PAGE_TYPE.STANDARD && isJobAdsContentBoostActive) {
    return [HOME_PAGE_ROUTE, JOBS_PAGE_ROUTE, BOOSTED_NEWSFEED_PAGE_ROUTE]
  }

  if (company?.pageType === COMPANY_PAGE_TYPE.STANDARD) {
    return [HOME_PAGE_ROUTE, JOBS_PAGE_ROUTE]
  }

  if (company?.pageType === COMPANY_PAGE_TYPE.PREMIUM) {
    return [HOME_PAGE_ROUTE, TEAMS_PAGE_ROUTE, JOBS_PAGE_ROUTE, NEWSFEED_PAGE_ROUTE]
  }

  return []
}
